import PacoteEntregaModel from "@/models/pacoteEntregaModel";

import { iServiceCached } from "./base/iServiceCached";

class PacoteEntregaService extends iServiceCached<PacoteEntregaModel> {
    constructor() {
        super("PacoteEntrega");
    }

    public async comboCached(franquiaId: number) {
        const retorno = await this.combo(franquiaId);
        return retorno.map(p => ({
            value: p.id,
            text: p.descricao,
            franquiaId: p.franquiaId,
        }));
    }
}

export default new PacoteEntregaService();

